// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"style_playerWrapper__bFSVY","loader":"style_loader__1fS7j"};